module.exports = __webpack_public_path__ + "img/farm.49e07a42.png";